import { List, ListItem } from '@mui/material';
import type { MenuItem, MenuKeyLabel, SubMenuItem } from '../NavigationSideMenu.types';
import { SideMenuItem } from './SideMenuItem';
import { SubMenuList } from './SubMenuList';

interface SideMenuListProps {
  items: (MenuItem & {
    selected: boolean;
    expanded: boolean;
    subItems?: (SubMenuItem & { selected: boolean })[];
  })[];
  onNavigate: (path?: string) => void;
  onToggleExpand: (key: MenuKeyLabel) => void;
  showLabel: boolean;
  variant: 'mobile' | 'desktop';
  translate: (key: string) => string;
}

export function SideMenuList({
  items,
  onNavigate,
  onToggleExpand,
  showLabel,
  variant,
  translate,
}: SideMenuListProps) {
  return (
    <List>
      {items.map(item => {
        const hasSelectedChild =
          item.subItems?.some((sub: SubMenuItem & { selected: boolean }) => sub.selected) ?? false;
        const isExpanded = item?.expanded;
        const isSelected = isExpanded
          ? item.selected && !hasSelectedChild
          : item.selected || hasSelectedChild;
        const subItems = item.subItems;

        return (
          // ListItem = <li> : seul enfant direct valide de <ul> (WCAG 1.3.1)
          <ListItem key={item.key} disablePadding sx={{ display: 'block' }}>
            <SideMenuItem
              label={translate(item.labelKey)}
              icon={item.icon}
              selected={isSelected}
              showLabel={showLabel}
              hasSubItems={!!item.subItems?.length}
              isExpanded={isExpanded}
              onClick={() => {
                if (item.subItems?.length) {
                  if (!showLabel) {
                    onNavigate(item.defaultPath ?? item.subItems[0].path);
                  } else {
                    onToggleExpand(item.key);
                  }
                } else {
                  onNavigate(item.path);
                }
              }}
            />
            {subItems && (
              <SubMenuList
                items={subItems}
                isExpanded={isExpanded}
                onNavigate={onNavigate}
                showLabel={showLabel}
                variant={variant}
                translate={translate}
              />
            )}
          </ListItem>
        );
      })}
    </List>
  );
}
